// import BlacklistState from 'blacklist/state/BlacklistState';
// import BotState from 'bots/state/BotState';
import EmployeeAccountState from 'employee/state/EmployeeAccountState';
import AreaState from "leads/area/state/AreaState";
// import RawLeadState from "leads/edit/state/RawLeadState";
// import LeadHistoryState from 'leads/history/state/LeadHistoryState';
// import JetLeadState from 'leads/jet/item/state/JetLeadState';
// import JetLeadsState from 'leads/jet/list/state/JetLeadsState';
// import LeadListState from 'leads/list/state/LeadListState';
// import LeadRevivalState from "leads/revival/state/LeadRevivalState";
// import MyTodayScoreState from 'leads/score/state/MyTodayScoreState';
import SignInUpState from 'login/state/SignInUpState';
import moment from 'moment-jalaali';
// import ConvertState from 'monitoring/convert/state/ConvertState';
// import EmployeeActivityLogState from 'monitoring/employees/activity/state/EmployeeActivityLogState';
// import LeadCountState from 'monitoring/employees/filing/leadcount/state/LeadCountState';
// import LeadMonitoringState from 'monitoring/employees/filing/state/LeadMonitoringState';
// import SupportMonitoringState from 'monitoring/employees/state/SupportMonitoringState';
// import AssignableTaskState from 'monitoring/filing/tasks/assignable/state/AssignableTaskState';
// import SpecialTasksState from 'monitoring/filing/tasks/special/state/SpecialTasksState';
// import UnassignedTaskState from 'monitoring/filing/tasks/unassigned/state/UnassignedTaskState';
// import JetLeadMonitoringState from 'monitoring/jet/state/JetLeadMonitoringState';
// import ProcessMonitoringState from 'monitoring/process/state/ProcessMonitoringState';
import React, { Component, Suspense, useContext, useEffect } from 'react';
import { Route, Routes, useLocation } from "react-router-dom";
import CaptchaState from 'shared/captcha/state/CaptchaState';
import { Loader } from 'shared/controls/Loader';
import { LanguageProvider } from 'shared/i18n/LanguageContext';
import ConfirmationState from 'shared/panels/confirmation/state/ConfirmationState';
import { Constants as AppConstants, AppContext } from 'shared/resources/Constants';
import AuthRoute from 'shared/system-controls/route/AuthRoute';
import { SessionContext, SessionProvider } from 'shared/system-controls/session/SessionProvider';
// import AccountingState from 'accounting/state/AccountingState';
// import AccountListState from 'accounts/list/state/AccountListState';
// import CouponState from 'coupons/state/CouponState';
// import AgentAccessState from 'services/filing/businesses/state/AgentAccessState';
// import JetServicesState from 'services/jet/state/JetServicesState';
// import TaskAssignmentState from 'tasks/assignment/state/TaskAssignmentState';
// import TaskHistoryState from 'tasks/history/state/TaskHistoryState';
// import TaskListState from 'tasks/list/state/TaskListState';
import AccountListState from 'accounts/list/state/AccountListState';
import OrderState from 'orders/state/OrderState';
import ProductState from 'products/state/ProductState';
import MainState from './state/MainState';
import AccountState from 'accounts/state/AccountState';
// import TaskUploadState from 'tasks/upload/state/TaskUploadState';

class ErrorBoundary extends Component {
	constructor(props) {
		super(props);
		this.state = { hasError: false };
	}

	static getDerivedStateFromError(error) {
		return { hasError: true };
	}

	componentDidCatch(error, errorInfo) {
		console.log(error, errorInfo);
	}

	render() {
		if (this.state.hasError) {
			if (AppConstants.DEVELOPMENT_MODE) return <></>;
			// window.location = "/";
		}

		return this.props.children;
	}
}

const LoginViewLazy = React.lazy(() => import('login/LoginView'));
const Login = () => <Suspense fallback={<Loader loading />}><CaptchaState><SignInUpState><LoginViewLazy /></SignInUpState></CaptchaState></Suspense>

const OrdersViewLazy = React.lazy(() => import('orders/OrdersView'));
const OrdersView = () => <Suspense fallback={<Loader loading />}><OrderState><OrdersViewLazy /></OrderState></Suspense>

const OrderActionViewLazy = React.lazy(() => import('orders/OrderActionView'));
const OrderActionView = () => <Suspense fallback={<Loader loading />}><OrderState><OrderActionViewLazy /></OrderState></Suspense>

const BOHomeViewLazy = React.lazy(() => import('home/BOHome'))
const BOHomeView = () => <Suspense fallback={<Loader loading />}><SignInUpState><BOHomeViewLazy /></SignInUpState></Suspense>

const MenuViewLazy = React.lazy(() => import('products/MenuView'))
const MenuView = () => <Suspense fallback={<Loader loading />}><ProductState><MenuViewLazy /></ProductState></Suspense>

const MenuEditViewLazy = React.lazy(() => import('products/MenuEditView'))
const MenuEditView = () => <Suspense fallback={<Loader loading />}><ProductState><MenuEditViewLazy /></ProductState></Suspense>

const ContentEditViewLazy = React.lazy(() => import('products/ContentEditView'))
const ContentEditView = () => <Suspense fallback={<Loader loading />}><ProductState><ContentEditViewLazy /></ProductState></Suspense>

const ContainerEditViewLazy = React.lazy(() => import('products/ContainerEditView'))
const ContainerEditView = () => <Suspense fallback={<Loader loading />}><ProductState><ContainerEditViewLazy /></ProductState></Suspense>

const ProductEditViewLazy = React.lazy(() => import('products/ProductEditView'))
const ProductEditView = () => <Suspense fallback={<Loader loading />}><ProductState><ProductEditViewLazy /></ProductState></Suspense>

const OrderEditViewLazy = React.lazy(() => import('orders/OrderEditView'))
const OrderEditView = () => <Suspense fallback={<Loader loading />}><ProductState><AccountState> <OrderState><OrderEditViewLazy /></OrderState></AccountState></ProductState></Suspense>

const OrderViewLazy = React.lazy(() => import('orders/OrderView'))
const OrderView = () => <Suspense fallback={<Loader loading />}><ProductState><AccountState> <OrderState><OrderViewLazy /></OrderState></AccountState></ProductState></Suspense>

const OfficialInvoiceViewLazy = React.lazy(() => import('orders/OfficialInvoiceView'))
const OfficialInvoiceView = () => <Suspense fallback={<Loader loading />}><ProductState><AccountState> <OrderState><OfficialInvoiceViewLazy /></OrderState></AccountState></ProductState></Suspense>

const EmployeeAccountViewLazy = React.lazy(() => import('employee/EmployeeAccountView'))
const EmployeeAccountView = () => <Suspense fallback={<Loader loading />}><EmployeeAccountState><EmployeeAccountViewLazy /></EmployeeAccountState></Suspense>

const AccountViewLazy = React.lazy(() => import('accounts/show/AccountView'))
const AccountView = () => <Suspense fallback={<Loader loading />}><AccountState><AccountViewLazy /></AccountState></Suspense>

const AccountListViewLazy = React.lazy(() => import('accounts/list/AccountListView'))
const AccountListView = () => <Suspense fallback={<Loader loading />}><AccountListState><AccountListViewLazy /></AccountListState></Suspense>

const CustomerAccountEditViewLazy = React.lazy(() => import('accounts/edit/customers/CustomerAccountEditView'))
const CustomerAccountEditView = () => <Suspense fallback={<Loader loading />}><AccountState><CustomerAccountEditViewLazy /></AccountState></Suspense>

const BusinessAccountEditViewLazy = React.lazy(() => import('accounts/edit/businesses/BusinessAccountEditView'))
const BusinessAccountEditView = () => <Suspense fallback={<Loader loading />}><AccountState><BusinessAccountEditViewLazy /></AccountState></Suspense>


//--------------------------------------------------------------------------
const PagesPanel = React.memo(({ sessionActive }) =>
	<Routes>
		<Route exact path='/login' element={<Login />} />
		<Route element={<Login />} />
		<Route path='/' element={<AuthRoute isAuthenticated={sessionActive} />} >
			<Route index element={<BOHomeView />} />
			<Route path='orders'>
				<Route index element={<OrdersView />} />
				<Route path='new' element={<OrderEditView />} />
				<Route path='process' element={<OrdersView />} />
				<Route path='delivery' element={<OrdersView />} />
				<Route path='error' element={<OrdersView />} />
				<Route path='finish' element={<OrdersView />} />
				<Route path=':orderID' element={<OrderEditView />} />
				<Route path=':orderID/detail' element={<OrderView />} />
				<Route path=':orderID/detail/print' element={<OrderView />} />
				<Route path='users/:userID/invoices' element={<OfficialInvoiceView />} />
				<Route path='actions'>
					<Route index element={<OrderActionView />} />
					<Route path='portion' >
						<Route index element={<OrdersView />} />
						<Route path='next' element={<OrderActionView />} />
					</Route>
					<Route path='packaging' >
						<Route index element={<OrdersView />} />
						<Route path='next' element={<OrderActionView />} />
					</Route>
				</Route>
			</Route>
			<Route path='products'>
				<Route index element={<MenuView />} />
				<Route path=':productID' element={<ProductEditView />} />
				<Route path=':productID/copy' element={<ProductEditView />} />
				<Route path='contents'>
					<Route index element={<MenuView />} />
					<Route path=':contentID' element={<ContentEditView />} />
				</Route>
				<Route path='containers'>
					<Route index element={<MenuView />} />
					<Route path=':containerID' element={<ContainerEditView />} />
				</Route>
				<Route path='menus'  >
					<Route index element={<MenuView />} />
					<Route path=':menuID' element={<MenuEditView />} />
					<Route path=':menuID/copy' element={<MenuEditView />} />
				</Route>
			</Route>
			<Route path='employees' >
				<Route index element={<EmployeeAccountView />} />
			</Route>
			<Route path='users'>
				<Route index element={<AccountListView />} />
				<Route path='customers' >
					<Route path=':userID' element={<CustomerAccountEditView />} />
					<Route path='businesses/:customerAccountID' element={<BusinessAccountEditView />} />
				</Route>
				<Route path='businesses/:userID' element={<BusinessAccountEditView />} />
				<Route path=':userID' >
					<Route index element={<AccountView />} />
					<Route path='history' element={<AccountView />} />
					<Route path='authenticate' element={<AccountView />} />
					{/*	<Route path='contracts' >
							<Route index element={<FoodContractEditView />} />
							<Route path='businesses/customers/:userID' element={<CustomerServiceEditView />} />
						</Route>*/}
					<Route path='tabs' >
						<Route path='*' element={<AccountView />} />
					</Route>
				</Route>
			</Route>

			{/*
			<Route path='tasks' >
				<Route path='review' element={<LeadReviewTaskView />} />
				<Route path='history/:taskID' element={<TaskHistoryView />} />
				<Route path='assignment' >
					<Route index element={<TaskAssignmentView />} />
					<Route path=':userID' element={<TaskAssignmentView />} />
				</Route>
				<Route path='list' element={<TaskListView />} />
				<Route path='special' element={<SpecialTasksView />} />
				<Route path='upload' element={<TaskUploadView />} />
			</Route>
			<Route path='monitoring'>
				<Route path='activity/:userID' element={<EmployeeActivityLogView />} />
				<Route path='jobs' element={<ProcessMonitoringView />} />
				<Route path='convert' element={<ConvertView />} />
				<Route path='leads' >
					<Route path='quality' element={<LeadQualityView />} />
					<Route path='special' element={<LeadSpecialView />} />
					<Route path='count' element={<LeadCountView />} />
					<Route path='regions/statistics'  >
						<Route index element={<RegionStatisticsView />} />
						<Route path='chart' element={<RegionStatisticsChartView />} />
					</Route>
				</Route>
				<Route path='tasks' >
					<Route path='assignable' element={<AssignableTaskView />} />
					<Route path='unassigned' element={<UnassignedTaskView />} />
				</Route>
			</Route>
			<Route path='employees' >
				<Route index element={<EmployeeAccountView />} />
			</Route>
			<Route path='bots'>
				<Route path='servers' >
					<Route index element={<BotServersView />} />
					<Route path='logs' element={<BotServersLogView />} />
					<Route path=':serverID' element={<BotServerView />} />
				</Route>
				<Route path='simcards' element={<SimcardsView />} />
				<Route path='proxies' element={<ProxyListView />} />
				<Route path='chatphones' >
					< Route index element={<ChatPhoneView />} />
					< Route path="sheypoor" element={<ChatPhoneView />} />
					< Route path="divar" element={<ChatPhoneView />} />
					< Route path="divar/hiddens" element={<ChatPhoneView />} />
				</Route>
			</Route>
			<Route path='jet' >
				<Route path='leads'>
					<Route index element={<JetLeadsView />} />
					<Route path='supervision' element={<JetLeadsView />} />
					<Route path=':leadID' element={<JetLeadView />} />
				</Route>
				<Route path='leads'>
					<Route path='regions'>
						<Route path='statistics'>
							<Route index element={<JetRegionStatisticsView />} />
						</Route>
					</Route>
					<Route path='special'>
						<Route index element={<JetLeadSpecialView />} />
					</Route>
				</Route>
			</Route> */}

			{/* <Route path='support'>
				<Route path='tasks' >
					<Route index element={<AccountView />} />
					<Route path=":taskUserID" element={<AccountView />} />
				</Route>

				<Route path='services/network' element={<NetworkServiceListView />} />
				<Route path='accounting'>
					<Route path='bank-accounts' element={<BankAccountEditView />} />
					<Route path='transactions' >
						<Route index element={<TransactionsView />} />
						<Route path='upload' element={<TransactionUploadView />} />
						<Route path='matching'  >
							<Route index element={<DepositMatchingView />} />
							<Route path=':bankTransactionID' element={<DepositMatchingView />} />
						</Route>
					</Route>
				</Route>
				<Route path='coupons'>
					<Route index element={<CouponListView />} />
					<Route path='edit/:couponID' element={<CouponEditView />} />
					<Route path='new' element={<CouponEditView />} />
				</Route>
				<Route path='jet'>
					<Route path='services'>
						<Route index element={<JetServicesView />} />
						<Route path=':serviceID' element={<JetServicesView />} />
					</Route>
				</Route>

			</Route> */}
		</Route>
	</Routes >
)

//--------------------------------------------------------------------------
const BitbiteMain = ({ screenWidth }) => {
	const location = useLocation();
	const { sessionLoaded, person, systemID } = useContext(SessionContext);
	const testMode = window?.location?.href?.includes('test.');

	//-----------------------------------------------------------------
	useEffect(() => {
		setTimeout(() => window.scrollTo(0, 0), 500);
	}, []);

	//-----------------------------------------------------------------
	useEffect(() => {
		moment.loadPersian({ dialect: 'persian-modern' });
	}, []);

	// console.log(person);
	if (!sessionLoaded) {
		return <></>
	}
	return (
		<AppContext.Provider value={{
			systemID: systemID,
			person: person,
		}}>
			{/* {([window.location.href, AppConstants.SERVER_IP_PORT].some(c => c?.indexOf('testk') >= 0 || c?.indexOf('31.14.116.170') >= 0)) &&
				< div className='bg-red-light -bottom-20 text-white fixed p-2 w-screen'>This is test server.</div>} */}
			{!!testMode && (
				<div className="fixed bottom-0 z-50 left-0 w-full bg-yellow-300 text-black text-center p-2 font-semibold flex flex-col gap-2">
					<span className='text-blue text-lg'>مد تست</span>
					<span className='text-red font-semibold text-xl'>هشدار: اطلاعات کاربران را تغییر ندهید</span>
				</div>
			)}
			<div className="min-h-screen flex flex-col justify-between bg-gray-100">
				<MainState>
					{!(location.pathname.indexOf('/support') >= 0) &&
						<AreaState>
							<ConfirmationState>
								{/* <TaskListState> */}
								<div className="w-full flex-grow flex flex-col items-center relative">
									<PagesPanel sessionActive={person && true} />
								</div>
								{/* </TaskListState> */}
							</ConfirmationState>
						</AreaState>
					}
					{!!(location.pathname.indexOf('/support') >= 0) &&
						// <AreaState>
						<ConfirmationState>
							<div className="w-full flex-grow flex flex-col items-center relative">
								<PagesPanel sessionActive={person && true} />
							</div>
						</ConfirmationState>
						// </AreaState>
					}
					{!!testMode && <div className='pb-20' />}

				</MainState>
			</div>
		</AppContext.Provider>
	)
}


const Main = (props) => <ErrorBoundary><LanguageProvider><SessionProvider sessionName="BITBITE_BO"><BitbiteMain {...props} /></SessionProvider></LanguageProvider></ErrorBoundary>

export default Main;
